import React from "react";
import getCodedValue from "../../utils/getCodedValue";

const AlternateContact = ({ data }) => {
  const givenNameHandler = (name) => {
    return (
      <div>
        <h4>First Name</h4>
        {name.given
          ? name.given.map((givenName, gnKey) => {
              return <div key={gnKey}>{givenName} </div>;
            })
          : "-"}
      </div>
    );
  };

  const familyNameHandler = (name) => {
    return (
      <div>
        <h4>Last Name</h4>
        <div>{name.family ? name.family : "-"}</div>
      </div>
    );
  };

  const relationshipHandler = (relation) => {
    return (
      <div>
        <h4>Relationship</h4>
        <div>{relation ? getCodedValue(relation) : "-"} </div>
      </div>
    );
  };

  return (
    <section>
      {data.map((contact, index) => (
        <div key={index}>
          {familyNameHandler(contact.name)}
          {givenNameHandler(contact.name)}
          {relationshipHandler(contact.relationship[0])}
        </div>
      ))}
    </section>
  );
};

export default AlternateContact;
